<script lang="ts" setup>
import type { PropType } from 'vue';
import { ref } from '#imports';
import BaseButton from '~/shared/components/buttons/base-button.vue';
import LinkBlockButton from '~/shared/components/buttons/link-block-button.vue';
import BaseInput from '~/shared/components/form/input/base-input.vue';

const props = defineProps({
  placeholder: {
    type: String,
    default: '',
  },
  error: {
    type: [String, Boolean],
    default: false,
  },
  name: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    default: '',
  },
  nonFocusable: {
    type: Boolean,
    default: false,
  },
  maxUrls: {
    type: Number,
    default: 3,
  },
});

const model = defineModel({
  type: Array as PropType<string[]>,
  required: true,
});

const inputUrl = ref('');

function onUrlInput(value: string) {
  if (model.value.length >= props.maxUrls) {
    inputUrl.value = '';
    return;
  }

  inputUrl.value = value;
}

function onAddUrl() {
  if (!inputUrl.value) return;
  model.value.push(inputUrl.value);
  inputUrl.value = '';
}
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <BaseInput
      v-bind="$props"
      :model-value="inputUrl"
      :placeholder="`Enter store url (max urls is ${maxUrls})`"
      @update:model-value="onUrlInput"
      @keyup.enter="onAddUrl"
    >
      <template #actionButton>
        <BaseButton type="button" label="Add link" size="sm" variant="primary" @click.prevent="onAddUrl" />
      </template>
    </BaseInput>

    <LinkBlockButton v-for="url in model" :text="url" @click="model = model.filter((item) => item !== url)" />
  </div>
</template>

<style lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>
